<template>
  <div class="container" v-if="simages.length > 0">
    <div class="panel panel-default">
      <div class="panel-footer">
        <div class="category">
          <a class="category-top">{{ name }}</a>
          <a class="category-bottom">{{ enname }}</a>
        </div>
      </div>
      <div class="panel-body imagesdao" style="padding: 0px">
        <div v-for="(image, index) in simages">
          <div :class="show ? 'long-text showLongText' : 'long-text hideLongText'">
             <div ref="elementtext" id="elementtext"> 
               <van-image @load="load" lazy-load :src="image.img_urls" @click="preview(image)" />
             </div>
          </div>
          <button
          type="button"
          :class="
            show
              ? 'showMore btn btn-primary btn-lg btn-block fanzhuan'
              : 'showMore btn btn-primary btn-lg btn-block'
          "
          @click="show = !show"
          v-if="height >= 400"
        ></button>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ImagePreview } from "vant";

export default {
  data() {
    return {
      show: false,
      height: 0,
      timer: null
    };
  },
  components: {
    [ImagePreview.Component.name]: ImagePreview.Component,
  },
  props: {
    simages: {
      type: Array,
      require: true,
    },
    name: {
      type: String,
      default: "平面导览",
    },
    enname: {
      type: String,
      default: "Plane guide",
    },
  },
  watch: {
    simages(val) {
      // console.log(val)
    },
  },
  methods: {
    preview(item) {
      ImagePreview({
        images: [item.img_urls],
      });
    },
    load(){
      // console.log('加载完成');
      let height = document.getElementById('elementtext')
      console.log(height.offsetHeight);
      this.height = height.offsetHeight;
    }
  },
  created() {
  },
};
</script>
<style>
.imagesdao .van-image {
  width: 100%;
  height: 100%;
  padding: 0 6px;
  margin: 6px 0;
}
</style>
<style scoped>
  .showLongText{
    padding: 0;
  }
  .hideLongText{
    max-height: 300px;
    padding: 0;
  }
</style>